import { useEffect } from "react";
import { trackEvent } from "@/lib/analytics";

/**
 * Fires a `section_view` event once per session for every element with
 * `data-track-section="<name>"` when it crosses 50% of the viewport.
 */
export function useScrollDepth() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const seen = new Set<string>();

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const name =
            (entry.target as HTMLElement).dataset.trackSection ||
            (entry.target as HTMLElement).id;
          if (!name || seen.has(name)) continue;
          seen.add(name);
          trackEvent("section_view", { section: name });
        }
      },
      { threshold: 0.5 }
    );

    const els = document.querySelectorAll<HTMLElement>("[data-track-section]");
    els.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}
